import { FC } from 'react';

import { Alert, Chip, Grid, Paper, Typography } from '@mui/material';

import { PurchaseOrderLookup } from '../model';
import ReceivingStatusBanner from './ReceivingStatusBanner';

interface PurchaseOrderBannersProps {
  purchaseOrder: PurchaseOrderLookup;
}

const PurchaseOrderBanners: FC<PurchaseOrderBannersProps> = ({ purchaseOrder }) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <ReceivingStatusBanner purchaseOrder={purchaseOrder} />
    </Grid>
    <Grid item xs={12}>
      <Paper style={{ padding: 16, height: '100%' }}>
        <Typography variant="overline" color="text.secondary">
          Department
        </Typography>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Typography variant="h6">{purchaseOrder.department || '—'}</Typography>
          </Grid>
          {purchaseOrder.count_items_warning && (
            <Grid item>
              <Chip label="COUNT ITEMS" color="warning" size="small" />
            </Grid>
          )}
        </Grid>
      </Paper>
    </Grid>
    {/* For Costco/Install the job's staging bay is the real destination. */}
    {purchaseOrder.job_bay_banner && (
      <Grid item xs={12}>
        <Paper style={{ padding: 16, backgroundColor: '#1976d2' }}>
          <Typography variant="h5" fontWeight="bold" style={{ color: '#fff' }}>
            {purchaseOrder.job_bay_banner}
          </Typography>
        </Paper>
      </Grid>
    )}
    {/* Rendered only when the buyer actually left a note — legacy always showed a bare header. */}
    {purchaseOrder.staging_note && (
      <Grid item xs={12}>
        <Alert severity="info">
          <strong>Staging Note:</strong> {purchaseOrder.staging_note}
        </Alert>
      </Grid>
    )}
  </Grid>
);

export default PurchaseOrderBanners;
